// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__RJUCe","left":"footer_left__AMqXy","right":"footer_right__m76nv"};